import BaseMystery from '../BaseMystery'

const FirstGloriousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/a/andrea/castagno/1_1440s/07passi3.jpg",
		"https://www.wga.hu/art/a/altdorfe/3/3predel1.jpg",
		"https://www.wga.hu/art/a/andrea/firenze/spanish/5vault1.jpg",
		"https://www.wga.hu/art/a/andrea/bartolo/predell3.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/08_women.jpg",
		"https://www.wga.hu/art/b/basaiti/resurrec.jpg",
		"https://www.wga.hu/art/b/bassano/francesc/resurrec.jpg",
		"https://www.wga.hu/art/b/bellini/giovanni/1470-79/095resur.jpg",
		"https://www.wga.hu/art/b/benvenut/predell3.jpg",
		"https://www.wga.hu/art/b/blake/071resur.jpg",
		"https://www.wga.hu/art/b/bouts/dirk_e/1/3resurre.jpg",
		"https://www.wga.hu/art/b/bronzino/3/resurrec.jpg",
		"https://www.wga.hu/art/g/giordano/1/resurrec.jpg",
		"https://www.wga.hu/art/g/giotto/padova/old/chris21.jpg",
		"https://www.wga.hu/art/g/greco_el/05/0509grec.jpg",
		"https://www.wga.hu/art/g/grunewal/2isenhei/2view/2view3r.jpg",
		"https://www.wga.hu/art/h/heuvel/resurrec.jpg",
		"https://www.wga.hu/art/j/jacopo/cione/1/1c2_up1.jpg",
		"https://www.wga.hu/art/k/konig/resurrec.jpg",
		"https://www.wga.hu/art/l/la_fosse/versail4.jpg",
		"https://www.wga.hu/art/l/lorenzet/pietro/1/3arch/2resurrx.jpg",
		"https://www.wga.hu/art/m/mantegna/04/zeno3p.jpg",
		"https://www.wga.hu/art/m/mariotto/life7.jpg",
		"https://www.wga.hu/art/m/master/ms/7resurr.jpg",
		"https://www.wga.hu/art/m/master/hausbuch/resurrec.jpg",
		"https://www.wga.hu/art/m/master/trebon/resurrec.jpg",
		"https://www.wga.hu/art/m/memling/6copies/08notri4.jpg",
		"https://www.wga.hu/art/m/multsche/wurzach/4resurr.jpg",
		"https://www.wga.hu/art/o/oggiono/resurrec.jpg",
		"https://www.wga.hu/art/p/parrocel/pierre/resurrec.jpg",
		"https://www.wga.hu/art/p/passigna/resurrec.jpg",
		"https://www.wga.hu/art/p/pleydenw/hans/hofaltar.jpg",
		"https://www.wga.hu/art/r/rembrand/12passio/04passio.jpg",
		"https://www.wga.hu/art/r/robusti/domenico/avogadr1.jpg",
		"https://www.wga.hu/art/r/rubens/11religi/05resur1.jpg",
		"https://www.wga.hu/art/s/seghers/gerard/resurrec.jpg",
		"https://www.wga.hu/art/t/tintoret/3_1560s/6cassia1.jpg",
		"https://www.wga.hu/art/t/tintoret/3b/2upper/2/24resur.jpg",
		"https://www.wga.hu/art/t/tiziano/04_1540s/3resurre.jpg",
		"https://www.wga.hu/art/v/veronese/04_1570s/1resurre.jpg",
		"https://www.wga.hu/art/v/verocchi/sculptur/1resurre.jpg",
	];

	const scriptureQuote = "\"Do not be afraid! I know that you are seeking Jesus the crucified. He is not here, for he has been raised just as he said. Come and see the place where he lay.\"";
	const scriptureCitation = "Matthew 28:5 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matthew+28%3A1-10&version=NABRE";

	return (
		<BaseMystery titleText="The Resurrection"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FirstGloriousMystery;